import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { CaseSearch } from '../models/case-search.model';
import { Contact } from '../models/contact.model';
import { specialPharmaciesJSON,oralMedicationJSON } from '../../../assets/Json/medicineInfo.json'
import { PIleftJSON, PIrightJSON, piApretudeJSON } from '../../../assets/Json/prescriptionInfo.json'

@Injectable({
  providedIn: 'root'
})
export class SharedFormService {

  public hideLoader: any = new Subject<boolean>();
  public filterCases: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isDashboard: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public formStatusEvent: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public stateEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public dashboardReloadEvent: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public myPatientNavigationEvent: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public dashboardRedirectConfirmEvent : BehaviorSubject<string> = new BehaviorSubject<string>("");
  public passwordResetRequired: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public confirmExit: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public confirmDelete: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public caseInProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public facilityChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public facilityChangePopup: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public displayPopup: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isSubmitPatientReferral: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public medicineName: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public lupus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public nephritis: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public consentEmail: BehaviorSubject<string> = new BehaviorSubject<string>("");
  private emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  private phonePattern = "^\(\d{3}\)[- ]\d{3}[- ]?\d{4}$";
  private zipPattern = "^[0-9]{5}$";
  public caseFilter: CaseSearch= null;

  public changeUsername: any = new BehaviorSubject<boolean>(false);
  public changePassword: any = new BehaviorSubject<boolean>(false);
  public reset: BehaviorSubject<string>=new BehaviorSubject<string>("reset-password");
  public sidebarValue: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public isRefreshed: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public functionRefresh: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public isRefreshCalled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public dashboardToMypatientMsg: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public caseStatusFromService: string[] = [];
  public statusFromService: string[] = [];
  public prevStatusFromDashboard: string = '';

  public getPrevStatusFromDashboard(): string {
    return this.prevStatusFromDashboard;
  }

  public setPrevStatusFromDashboard(value: string): void {
    this.prevStatusFromDashboard = value;
  }
  public setFilters(cases: string[], caseStatus: string[]) {
    this.caseStatusFromService = [...caseStatus];
    this.statusFromService = [...cases];
  }



  public sendMessage(message: string) {
    this.dashboardToMypatientMsg.next( message );
  }

  public getMessage(): Observable<any> {
    return this.dashboardToMypatientMsg.asObservable();
  }
  
  public clearMessage() {
    this.dashboardToMypatientMsg = new BehaviorSubject<string>('');
  }

  states: any[]  = [
    { label: 'AL', value: 'AL' },
    { label: 'AK', value: 'AK' },
    { label: 'AR', value: 'AR' },
    { label: 'AS', value: 'AS' },
    { label: 'AZ', value: 'AZ' },
    { label: 'CA', value: 'CA' },
    { label: 'CO', value: 'CO' },
    { label: 'CT', value: 'CT' },
    { label: 'DC', value: 'DC' },
    { label: 'DE', value: 'DE' },
    { label: 'FL', value: 'FL' },
    { label: 'GA', value: 'GA' },
    { label: 'GU', value: 'GU' },
    { label: 'HI', value: 'HI' },
    { label: 'IA', value: 'IA' },
    { label: 'ID', value: 'ID' },
    { label: 'IL', value: 'IL' },
    { label: 'IN', value: 'IN' },
    { label: 'KS', value: 'KS' },
    { label: 'KY', value: 'KY' },
    { label: 'LA', value: 'LA' },
    { label: 'MA', value: 'MA' },
    { label: 'MD', value: 'MD' },
    { label: 'ME', value: 'ME' },
    { label: 'MI', value: 'MI' },
    { label: 'MN', value: 'MN' },
    { label: 'MO', value: 'MO' },
    { label: 'MP', value: 'MP' },
    { label: 'MS', value: 'MS' },
    { label: 'MT', value: 'MT' },
    { label: 'NC', value: 'NC' },
    { label: 'ND', value: 'ND' },
    { label: 'NE', value: 'NE' },
    { label: 'NH', value: 'NH' },
    { label: 'NJ', value: 'NJ' },
    { label: 'NM', value: 'NM' },
    { label: 'NV', value: 'NV' },
    { label: 'NY', value: 'NY' },
    { label: 'OH', value: 'OH' },
    { label: 'OK', value: 'OK' },
    { label: 'OR', value: 'OR' },
    { label: 'PA', value: 'PA' },
    { label: 'PR', value: 'PR' },
    { label: 'RI', value: 'RI' },
    { label: 'SC', value: 'SC' },
    { label: 'SD', value: 'SD' },
    { label: 'TN', value: 'TN' },
    { label: 'TT', value: 'TT' },
    { label: 'TX', value: 'TX' },
    { label: 'UT', value: 'UT' },
    { label: 'VA', value: 'VA' },
    { label: 'VI', value: 'VI' },
    { label: 'VT', value: 'VT' },
    { label: 'WA', value: 'WA' },
    { label: 'WI', value: 'WI' },
    { label: 'WV', value: 'WV' },
    { label: 'WY', value: 'WY' }
  ];
  officeContact : any[] = [
    {label: 'Receptionist', value:'Receptionist'},
    {label: 'Office Manager', value:'Office Manager'}
  ]

  professionalType: any[] = [
    { label: 'Nurse', value: 'Nurse'},
    {label: 'Nurse Practioner', value:'Nurse Practioner'}
  ]
  constructor(@Inject('API_URL') private apiUrl: any, private http: HttpClient) { 
  }
  getStatesData(): any[] {
    return this.states;
  }
  getOfficeContact(): any {
    return this.officeContact;
  }
  getOfficeProfessional(): any {
    return this.professionalType;
  }
  getSpecialPharmacies():any{
    return specialPharmaciesJSON;
  }
  getPIleftJSON():any{
    return PIleftJSON;
  }
  getPIrightJSON():any{
    return PIrightJSON;
  }
  getPIApretudeJSON():any{
    return piApretudeJSON;
  }
  getOralMedications():any{
    return oralMedicationJSON;
  }

  getLookUpValues(sendValues: string[]): void {
    const lookUps = sendValues.join(',');

    let url: string = `${this.apiUrl.baseUrl}lookups/${lookUps}`
    this.http.get<any>(url, {
      headers: {}
    }).subscribe(resp => {
      //console.log('Returned Back something =>', resp);
      if(resp.Status === 'SUCCESS') {
        this.officeContact  = resp.Payload.OfficeContactType.map( item => {
          return {
            label: item.Value,
            value: item.Id
          }
        });
        this.professionalType = resp.Payload.ProfessionalTitle.map( item => {
          return {
            label: item.Value,
            value: item.Id
          }
        });
       // console.log('Converted drop downs =>', this.officeContact, this.professionalType);
      }
    },
    err => console.log('The error =>', err))
  }
  public addToFormGroup(formGroup, formGroupObj) {
    for (let control in formGroupObj) {
      if (formGroupObj.hasOwnProperty(control) && !formGroup.get(control)) {
        formGroup.addControl(control, formGroupObj[control]);
      }
    }
  }
  public getContactFormTemplate(counter: string, fb: FormBuilder, patterns:any, contact?: Contact): any {
    const dynamicForm = {};
    if(!contact) {
      contact = {};
      contact.Phone = {};
    }
    dynamicForm['officeContactType' + counter] = fb.control(contact.OfficeContactId ? contact.OfficeContactType : null);
    dynamicForm['officeFirstName' + counter] = fb.control(contact.FirstName ? contact.FirstName : null, Validators.required);
    dynamicForm['officeLastName' + counter] = fb.control(contact.LastName ? contact.LastName : null, Validators.required);
    dynamicForm['officeProfessional' + counter] = fb.control(contact.Title ? contact.TitleId : 1);
    dynamicForm['officeProfessionalType' + counter] = fb.control(contact.Title ? contact.Title : 1);
    dynamicForm['officeContactId' + counter] = fb.control(contact.OfficeContactType ? contact.OfficeContactId : 1, Validators.required);
    dynamicForm['officePhone' + counter] = fb.control(contact.Phone.Number ? contact.Phone.Number : null, Validators.required);
    dynamicForm['officeExtension' + counter] = fb.control(contact.Phone.Extension ? contact.Phone.Extension : null, [Validators.minLength(2)]);
    dynamicForm['officeFaxNumber' + counter] = fb.control(contact.Fax ? contact.Fax : null);
    dynamicForm['officeEmail' + counter] = fb.control(contact.Email ? contact.Email : null);

    return dynamicForm;

  }
  
  public getFacilityFormTemplate(counter: number, fb: FormBuilder, patterns: any): any {
    const dynamicForm = {};
    dynamicForm['practiceGroup' + counter] = fb.control('', Validators.required);
    dynamicForm['officeName' + counter] = fb.control('', Validators.required);
    dynamicForm['officeAddress1' + counter] = fb.control('', Validators.required);
    dynamicForm['officeAddress2' + counter] = fb.control('');
    dynamicForm['city' + counter] = fb.control('', Validators.required);
    dynamicForm['state' + counter] = fb.control('', Validators.required);
    dynamicForm['zip' + counter] = fb.control('', [Validators.required, Validators.pattern(patterns.zip)]);
    dynamicForm['phoneNumber' + counter] = fb.control('', [Validators.required, Validators.pattern(patterns.phone)]);
    dynamicForm['ext' + counter] = fb.control('', [Validators.required, Validators.minLength(2)]);
    dynamicForm['fax' + counter] = fb.control('',[Validators.required, Validators.pattern(patterns.phone)]);
    dynamicForm['emailAddress' + counter] = fb.control('', [Validators.required, Validators.email, Validators.pattern(patterns.email)]);
  }
  public getChunkSize(strIn: string, length: number): string {
    const splitArr = strIn.match(new RegExp('.{1,' + length + '}', 'g'));
    return splitArr.join(' ');
  }
  // public isRefreshed: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  // public functionRefresh: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  // public isRefreshCalled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  get email():string{
    return this.emailPattern;
  }
  get phone(): string{
    return this.phonePattern;
  }
  get zip(): string{
    return this.zipPattern;
  }
}
